
import { computed, defineComponent, onMounted, reactive, ref, inject } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from '../store/index'
export default defineComponent({
  name: 'Category',
  setup() {
    const baseAPIURL = inject('baseAPIURL')
    const store = useStore()
    const dialogVisible = ref(false)
    const editMode = ref('')
    const categories = computed(() => store.state.example.categories)
    const isLoading = computed(() => store.getters.isLoading)
    const formData = ref({
      name: '',
      desc: '',
      coverImage: ''
    })
    const triggerEdit = (index: number) => {
      dialogVisible.value = true
      const { name, desc, coverImage, _id } = categories.value[index]
      editMode.value = _id
      formData.value = {
        name,
        desc,
        coverImage
      }
      // schema.properties.coverImage.default = coverImage
    }
    const schema = reactive({
      type: 'object',
      required: [
        'name',
        'desc',
      ],
      properties: {
        name: {
          type: 'string',
          title: '分类名称',
          default: 'Liu.Jun',
        },
        desc: {
          type: 'string',
          title: '描述',
          'ui:options': {
            placeholder: '请输入分类的描述',
            type: 'textarea',
            rows: 5
          }
        },
        coverImage: {
          "anyOfSelect": {
              "ui:widget": "RadioWidget",
              "ui:title": "背景图片",
              "ui:options": {}
          },
          anyOf: [
            {
              title: "上传图片",
              type: "string",
              default: "",
              "ui:action": `${baseAPIURL}/api/upload`,
              "ui:with-credentials": true,
              "ui:list-type": "picture",
              "ui:widget": "UploadWidget",
              "ui:btnText": "上传头图"
            }, 
            {
              title: "直接填写URL",
              type: "string",
            }
          ]
        }
      }
    })
    
    const onCreateNew = () => {
      formData.value = {
        name: '',
        desc: '',
        coverImage: ''
      }
      dialogVisible.value = true
      editMode.value = ''  
    }
    const onCancel = () => {
      dialogVisible.value = false
    }
    const onSubmit = async () => {
      if (editMode.value === '') {
        await store.dispatch('createCategory', { data: formData.value })
        ElMessage({
          type: 'success',
          message: '创建成功',
          duration: 1000
        })
        dialogVisible.value = false
      } else {
        console.log(formData.value)
        await store.dispatch('updateCategory', { urlParams: { id: editMode.value }, data: formData.value })
        ElMessage({
          type: 'success',
          message: '更新成功',
          duration: 1000
        })
        dialogVisible.value = false
      }
    }
    const onUpdateSort = async (id: string, value: string) => {
      console.log(id, value)
      await store.dispatch('updateCategory', { urlParams: { id }, data: { sort: parseInt(value) } })
      ElMessage({
        type: 'success',
        message: '更新成功',
        duration: 1000
      })
    }
    const onDelete = (id: string) => {
      ElMessageBox.confirm('是否要永久删除该分类？特别注意该分类下的实例会受影响！',  '删除分类', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('deleteCategory', { urlParams: { id }})
        ElMessage({
          type: 'success',
          message: '删除成功',
          duration: 1000
        })
      }).catch((e) => {
        throw e
      })
    }
    onMounted(() => {
      store.dispatch('getCategories')
    })
    return {
      categories,
      schema,
      formData,
      triggerEdit,
      dialogVisible,
      onCancel,
      onSubmit,
      onCreateNew,
      editMode,
      onDelete,
      isLoading,
      onUpdateSort
    }
  }
});
